import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    checkAuthStatus();
    // eslint-disable-next-line
  }, []);

  // Securely check token validity with backend
  const checkAuthStatus = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const storedUserData = localStorage.getItem('userData');
      if (token) {
        // Call backend to validate token
        const resp = await fetch('https://sims.ethnotech.in/api/protected', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (resp.ok) {
          setIsAuthenticated(true);
          if (storedUserData) setUserData(JSON.parse(storedUserData));
        } else {
          // Token invalid/expired, force logout
          logout();
        }
      } else {
        setIsAuthenticated(false);
        setUserData(null);
      }
    } catch (error) {
      console.error('Auth check error:', error);
      setIsAuthenticated(false);
      setUserData(null);
    } finally {
      setLoading(false);
    }
  };

  const login = (token, user) => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('userData', JSON.stringify(user));
    setIsAuthenticated(true);
    setUserData(user);
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    setIsAuthenticated(false);
    setUserData(null);
  };

  const value = {
    isAuthenticated,
    loading,
    userData,
    login,
    logout,
    checkAuthStatus
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
